import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import Card from "../Components/Card";
import "./CardSwipper.css";
import { useEffect, useState } from "react";
import ModalForHide from "../Components/ModalForHide";
import NotDirectLinkPopup, {
  warningSuppliers,
} from "../Components/NotDirectLinkPopup";
import SignUpFreeTrialButton from "../../Home/components/SignUpFreeTrialButton";
import AdvancedDataModal from "../Components/AdvancedDataModal";
import MessageBeforeLinkPopup from "../Components/MessageBeforeLinkPopup";
import {
  checkGatedBatch,
  getGatedColor,
  passesGatedFilters,
} from "../../../utils";

function CardSwipper(props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [innerPage, setInnerPage] = useState(1);
  const [isInnerLoading, setInnerLoading] = useState(false);
  const [hideModalProduct, setHideModalProduct] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [advancedDataProduct, setAdvancedDataProduct] = useState(null);
  const [showMessageObj, setShowMessageObj] = useState(null);

  const openSuppLink = (product) => {
    if (product.source_name === "b2bsportswear") {
      product.url = product.url.replace("+", "").replace("--", "-")
    }
    if (!warningSuppliers.includes(product.source_name)) {
      window.open(
        product.url.replace(
          "X".repeat(product.source_name.length),
          product.source_name
        )
      );
    } else {
      setLinkUrl(
        product.url.replace(
          "X".repeat(product.source_name.length),
          product.source_name
        )
      );
    }
  };

  useEffect(() => {
    const unLoad = () => {
      setInnerLoading(false);
    };
    setTimeout(unLoad, 5);
  }, [innerPage]);

  const hasSeller =
    props.sellerId && props.sellerId !== "none" && props.sellerId !== "";

  // Fetch per-seller gated statuses for any ASINs we haven't checked yet.
  // Mirrors the desktop table's effect; the homepage demo deck passes no
  // sellerId so it never runs there.
  useEffect(() => {
    if (!hasSeller || !props.data || props.data.length === 0 || !props.setGatedStatus) {
      return;
    }
    const asinsToCheck = [];
    props.data.forEach((prd) => {
      const asin = prd.asin.split("/")[prd.asin.split("/").length - 1];
      if (!props.gatedStatus.hasOwnProperty(asin)) {
        asinsToCheck.push(asin);
      }
    });
    if (asinsToCheck.length > 0) {
      checkGatedBatch(props.sellerId, asinsToCheck, props.refreshToken, (data) => {
        Object.entries(data).forEach(([asin, response]) => {
          props.setGatedStatus((prevGS) => ({
            ...prevGS,
            [asin]: response,
          }));
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data, props.sellerId]);

  const gatedFilterActive =
    props.filters &&
    (props.filters.filterOutGated || props.filters.showOnlyUngated);

  const visibleData = gatedFilterActive
    ? props.data.filter((product) =>
        passesGatedFilters(props.filters, props.gatedStatus ?? {}, product)
      )
    : props.data;

  // A toggled filter or a fresh server page can shrink the list below the
  // current deck position — restart the deck instead of showing an empty slice.
  useEffect(() => {
    setInnerPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data, props.filters?.filterOutGated, props.filters?.showOnlyUngated]);

  if (isInnerLoading) {
    return <progress className="progress" style={{ height: "100vh" }} />;
  }

  return (
    <>
      <Swiper
        spaceBetween={250}
        pagination={{
          dynamicBullets: true,
        }}
        effect={"cards"}
        modules={[Pagination, EffectCards]}
        onSlideChange={(e) => {
          setActiveIndex(e.activeIndex);
          if (e.activeIndex === 5) {
            setInnerPage((currPage) => currPage + 1);
            setInnerLoading(true);
          }
        }}
        style={{ width: "75vw" }}
      >
        {visibleData
          .slice((innerPage - 1) * 5, innerPage * 5)
          .map((product, index) => {
            return (
              <SwiperSlide key={index}>
                <Card
                  product={product}
                  filters={props.filters}
                  gatedColor={
                    hasSeller
                      ? getGatedColor(props.gatedStatus ?? {}, product)
                      : "white"
                  }
                  isFirstCard={index === 0}
                  active={index === activeIndex}
                  setLinkUrl={setLinkUrl}
                  linkUrl={linkUrl}
                  warningSuppliers={warningSuppliers}
                  openSuppLink={openSuppLink}
                  setShowMessageObj={setShowMessageObj}
                  showMessageObj={showMessageObj}
                  reportMismatch={props.reportMismatch}
                />
              </SwiperSlide>
            );
          })}
        <SwiperSlide style={{ width: "70vw" }}>
          <div
            style={{
              display: "flex",
              height: "55vh",
              backgroundColor: "#e6cede",
              textAlign: "center",
              justifyContent: "center",
              verticalAlign: "center",
            }}
          >
            {!props.hasOwnProperty("homePage") ? (
              <div style={{ margin: "auto" }}>
                {gatedFilterActive &&
                  props.data.length > 0 &&
                  visibleData.length === 0 && (
                    <p style={{ fontSize: "4vw", padding: "0 4vw 4vw" }}>
                      {hasSeller
                        ? "All products on this page are gated for you."
                        : "Connect your Amazon account to check gated status."}
                    </p>
                  )}
                <button
                  className="button is-rounded"
                  style={{
                    fontSize: "5vw",
                    padding: "0px 5vw",
                    backgroundColor: "#8B3C7E",
                    color: "white",
                    boxShadow: "0px 0px 5px 0px black",
                  }}
                  onClick={() => {
                    setInnerPage(1);
                    props.setPage((page) => page + 1);
                  }}
                >
                  Load More
                </button>
              </div>
            ) : (
              <div style={{ margin: "auto", fontSize: "3vh" }}>
                {" "}
                For more, sign up to Nepeto and try our free trial!
                <br />
                <br />
                <br />
                <SignUpFreeTrialButton />
              </div>
            )}
          </div>
        </SwiperSlide>
        {!props.hasOwnProperty("homePage") && (
          <>
            <br />
            <button
              className="button is-danger"
              onClick={() => {
                let prod = visibleData[(innerPage - 1) * 5 + activeIndex];
                if (prod) {
                  setHideModalProduct(prod);
                }
              }}
            >
              Hide
            </button>
            <img
              className="graphicon"
              alt="graph"
              onClick={() =>
                setAdvancedDataProduct(
                  visibleData[(innerPage - 1) * 5 + activeIndex] ?? null
                )
              }
              src={"/assets/graphtransparent.png"}
              style={{
                width: "66px",
                height: "40px",
                borderRadius: "10px",
                border: "2px solid gray",
                padding: "5px 18px",
                float: "right",
                backgroundColor: advancedDataProduct !== null && "lightgreen",
              }}
            />
          </>
        )}
      </Swiper>
      {hideModalProduct !== "" && (
        <ModalForHide
          isMobile={true}
          setHideModalProduct={setHideModalProduct}
          hideModalProduct={hideModalProduct}
          hideCredits={props.hideCredits}
        />
      )}
      {linkUrl !== "" && (
        <NotDirectLinkPopup
          isMobile={true}
          setLinkUrl={setLinkUrl}
          linkUrl={linkUrl}
        />
      )}
      {advancedDataProduct !== null && (
        <AdvancedDataModal
          advancedDataProduct={advancedDataProduct}
          setAdvancedDataProduct={setAdvancedDataProduct}
          isMobile={true}
        />
      )}
      {showMessageObj !== null && (
        <MessageBeforeLinkPopup
          showMessageObj={showMessageObj}
          setShowMessageObj={setShowMessageObj}
          isMobile={true}
        />
      )}
    </>
  );
}

export default CardSwipper;
